import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  baseUrl = environment.apiUrl + 'Company/';
  baseUrl2 = environment.apiUrl + 'RecordsDLP/';
  baseUrl3 = environment.apiUrl + 'RecordsIRM/';
  baseUrl4 = environment.apiUrl + 'Copilot/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location
  ) {}

  getSecurityBreachesCount({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl2 + 'getSecurityBreachesCount', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getDocumentLebeledCount({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'labeledCountByPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getIdentifiedAlertsCount({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl2 + 'identifiedAlertsCount', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTaggingUsersCount({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'taggingUsersByPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getInformationGraphsByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl2 + 'getInformationGraphsByCompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getLabelsGraphByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'getLabelsBycompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopIncidentsUsersByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl2 + 'getTopIncidentsUsersByCompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopDeniedUsersByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'getTopDeniedUsersByCompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTaggingChampion({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'taggingChampion', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getDepartamentLabel({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'departmentLabelsForPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopLabelsByDept({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'topLabelsByDeptForPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getCopilotInteractionsCount({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'interactionCount', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopCopilotUsers({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'topUsers', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopCopilotInteractionsByDepartment({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'interactionsByDepartment', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }
}
